import React, { useEffect, useState } from 'react';
import sessionsService from '../../../services/sessionsServices';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';

const RenameChatModal = ({ onClose, data }) => {
  const queryClient = useQueryClient();
  const [title, setTitle] = useState('');

  // Session titles are stored as HTML; strip tags so the input shows plain text.
  useEffect(() => {
    if (data?.title) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data?.title;
      setTitle(tempDiv.innerText.trim());
    }
  }, [data?.title]);

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.updateSession({
        platform_id: 'splylabs',
        session_id: data?.id,
        title: title.trim(),
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-[#161616] border border-[#262626] rounded-xl p-6 w-full max-w-md"
        onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold text-white mb-4">Edit Chat Title</h3>
        <div className="mb-6">
          <label htmlFor="chat-title" className="text-sm text-[#a0a0a0] mb-1.5 block">
            Chat Title
          </label>
          <input
            id="chat-title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="Enter chat title"
            className="w-full bg-[#0e0e0e] border border-[#262626] rounded-lg px-3 py-2 text-sm text-white placeholder:text-[#606060] outline-none focus:border-primary/40"
          />
        </div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-[#a0a0a0] hover:text-white">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleSubmit.mutate()}
            disabled={!title.trim() || handleSubmit.isPending}
            className="px-4 py-2 text-sm font-medium bg-primary hover:bg-primary/90 text-black rounded-lg disabled:opacity-50">
            {handleSubmit.isPending ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameChatModal;
